@if ((integrationsQuery.selectLoading() | async) === true) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}

@if ((integrationsQuery.selectLoading() | async) === false) {
  <div>
    <ag-grid-angular
      class="ag-theme-alpine integration-table tabular-nums"
      style="width: 1100px"
      [rowData]="gridData$ | async"
      [gridOptions]="gridOptions"
      [domLayout]="'autoHeight'"
    />
    <div
      class="flex h-9 items-end justify-between"
      style="margin-bottom: 15px; margin-top: 50px; width: 1100px"
    >
      <span class="text-xl text-aux-black">Available Integrations</span>
      <span class="text-aux-black">
        Contact
        <a class="btn--hyperlink cursor-pointer" href="mailto: integrations@auxili.us">
          integrations&#64;auxili.us
        </a>
        to add integrations to Auxilius
      </span>
    </div>
    <div class="flex flex-wrap justify-between" style="width: 1100px">
      @for (int of integrationVendors; track int) {
        <div
          class="mb-2 grid grid-rows-3 items-center border-2 border-aux-gray-dark p-1"
          style="width: 208px; height: 175px"
        >
          <div class="row-span-2 flex items-center justify-center">
            <img
              style="max-height: 150px; max-width: 150px"
              class="flex justify-center"
              [src]="int.logo"
              [alt]="int.name"
            />
          </div>
          <div class="row-span-1">
            <div class="flex justify-center text-xl text-aux-black">{{ int.name }}</div>
            <div class="flex justify-center text-base text-aux-gray-darkest">{{ int.type }}</div>
          </div>
        </div>
      }
    </div>
  </div>
}
